import { Globe, Plus } from "lucide-react";
import { Reveal } from "./Reveal";
import { useCheckout } from "../hooks/useCheckout";

const OPTION = {
  id: "hosting",
  lookup: "hosting_yearly",
  icon: Globe,
  name: "Hébergement seul",
  price: "26,99 €/an",
  desc: "Votre site en ligne toute l'année, hébergé chez OVHcloud (France) : hébergement sécurisé (https), sauvegardes et mise en ligne incluses. Abonnement annuel sans engagement, idéal si vous ne souhaitez pas de maintenance.",
};

export const Options = () => {
  const { loadingId, checkout } = useCheckout();
  const loading = loadingId === OPTION.id;
  return (
    <div className="mt-16" data-testid="options-section">
      <div className="mx-auto max-w-2xl text-center">
        <Reveal>
          <p className="font-mono text-xs font-semibold uppercase tracking-[0.22em] text-gold-dark">Option à la carte</p>
        </Reveal>
        <Reveal delay={0.08}>
          <h3 className="mt-4 font-display text-xl font-bold tracking-tight text-navy sm:text-2xl">Besoin uniquement d'un hébergement ?</h3>
        </Reveal>
      </div>
      <Reveal delay={0.14}>
        <article
          data-testid={`option-card-${OPTION.id}`}
          className="group mx-auto mt-8 flex max-w-3xl flex-col items-center gap-5 rounded-3xl border border-navy/10 bg-white p-6 text-center transition-all duration-300 hover:border-gold/40 hover:shadow-xl hover:shadow-gold/10 sm:flex-row sm:text-left sm:p-7"
        >
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-navy text-gold transition-transform duration-300 group-hover:scale-110">
            <OPTION.icon size={20} />
          </span>
          <div className="flex-1">
            <h4 className="font-display text-lg font-bold text-navy">
              {OPTION.name} — <span className="text-gold-dark">{OPTION.price}</span>
            </h4>
            <p className="mt-1 text-sm leading-relaxed text-slate-600">{OPTION.desc}</p>
          </div>
          <button
            data-testid={`option-cta-${OPTION.id}`}
            onClick={() => checkout(OPTION.id, OPTION.lookup)}
            disabled={loading}
            className="flex shrink-0 items-center justify-center gap-2 rounded-full border border-navy/15 px-5 py-2.5 text-sm font-semibold text-navy transition-all hover:border-gold hover:bg-gold/10 hover:text-gold-dark disabled:opacity-60"
          >
            <Plus size={14} /> {loading ? "Redirection paiement…" : "S'abonner"}
          </button>
        </article>
      </Reveal>
    </div>
  );
};
